import {Layout, Spacer} from '@di-nxt/components';
import React, {Fragment} from 'react';
import {TabItem} from './TabItems';
import {TabProps} from './types';

export const Tab: React.FC<TabProps> = ({
  selectedIndex,
  titles,
  onSelectTab,
}) => {
  return (
    <Layout
      height={44}
      paddingHorizontal="20"
      borderBottomColor="border_mono_15"
      borderBottomStyle="solid"
      borderBottomWidth="1">
      {titles.map((t, index) => (
        <Fragment key={index}>
          <TabItem
            index={index}
            selected={index === selectedIndex}
            title={t}
            onSelect={onSelectTab}
          />
          <Spacer width="20" />
        </Fragment>
      ))}
    </Layout>
  );
};
